/**
 * Consent copy: the measurement banner, the Create Account notice and the EMAIL COMMUNICATIONS clause.
 *
 * GENERATED from docs/behavior/legal-copy.md, whose blocks were read back from production's
 * rendered DOM (source sha256 ae4b0348bf4c4fc04bced410195ee51938ee1bc4692a733f1e3c35f63722de53).
 * No sentence was retyped. Styles are owned by the rendering components; this file carries
 * words and inline semantics only.
 */
import type { LegalNode } from './types';

export interface ConsentBannerCopy {
  readonly label: string;
  readonly message: readonly LegalNode[];
  readonly allow: string;
  readonly refuse: string;
}

/** legal-copy.md §1 */
export const CONSENT_BANNER: ConsentBannerCopy = {
  label: 'Measurement consent',
  message: [
    'Measuring our traffic and where it comes from tells us what works. Allow or refuse; the site works the same. ',
    { tag: 'a', href: '/privacy', children: ['Privacy'] },
  ],
  allow: 'Allow',
  refuse: 'Refuse',
};

/** legal-copy.md §3 (sha256 94bdba33…) */
export const SIGNUP_CONSENT_NOTICE =
  'Creating an account subscribes you to MUTATIO618 email. You can unsubscribe at any time — every message carries a one-click link.';

/** legal-copy.md §4 — shown on the Terms page only (ML-D5). */
export const EMAIL_COMMUNICATIONS = {
  title: 'EMAIL COMMUNICATIONS',
  paragraphs: [
    'When you create an account on mutatio618.com, you are subscribed to MUTATIO618 email, which includes our introductory sequence and occasional messages about the work, new material and offers.',
    'You may unsubscribe at any time. Every message we send carries an unsubscribe link in its footer and supports one-click unsubscribe in your mail client. Unsubscribing ends marketing email only — we will still contact you about your account and any order you place.',
    'We do not sell or rent your email address.',
  ],
} as const;

/** legal-copy.md §6 */
export const PASSWORD_EYE_LABELS = { show: 'Show password', hide: 'Hide password' } as const;
